import React, { useState,useEffect, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SectionHeading from "../SectionHeading";
import PlannedSpentBudgetChart from "./PlannedSpentBudgetChart";
import PlannedAllocationChart from "./PlannedAllocationChart";
import BudgetDistributionChart from "./BudgetDistributionChart";
import { PublicApi } from "api/api";
import { CommonDataContext } from "contexts/CommonDataContext/CommonDataContext";
import { useTranslation } from "react-i18next"; 
import { formatCurrency } from "utility/index";

const publicApi = new PublicApi();

const countryNames = ['Bosnia and Herzegovina','Kosovo','Montenegro','North Macedonia','Serbia']

function CountryBudget({country,id}) {
  const [selectedYear, setSelectedYear] = useState("2024");
  const [yearsList,setYearsList] = useState([]);
  const [budgetList,setBudgetList] = useState([]);
  const [totalBudget,setTotalBudget] = useState();
  const [plannedBudgetList,setPlannedBudgetList] = useState([]);
  const [totalPlannedBudget,setTotalPlannedBudget] = useState();
  const [areaBudgetList,setAreaBudgetList] = useState([]);
  const context = useContext(CommonDataContext); 
  const [selectedCountry,setSelectedCountry] = useState({});

  const { t } = useTranslation();

   // convert country name like "Serbia" → translation key "country.serbia"
   const countryKey = `country:${country?.toLowerCase().replace(/\s+/g, "-")}`;
   const translatedCountry = t(countryKey, country); // fallback to original if not found

  useEffect(() => {
    setSelectedCountry(context?.countries?.find(data => data.id === id));
  },[id])

  

  const handleSelect = (year) => {
    setSelectedYear(year);
  };

  const getAllYearsList = async () => {
    const response = await publicApi.apiPublicGetAllYearsList();
    setYearsList(response?.data?.yearsList)
  }

  const getBudgetByYear = async (year) => {
    const budgetResponse = await publicApi.apiPublicGetBudgetCountry({countryId:id,year:year});
    setBudgetList([{
      name : 'Plan Budget',
      budget : budgetResponse?.data?.planBudget
    },{
      name : 'Spent Budget',
      budget : budgetResponse?.data?.spentBudget
    }]);
    setTotalBudget(budgetResponse?.data?.totalBudget)
    const plannedBudgetResponse = await publicApi.apiPublicGetPlannedBudgetCountry({countryId:id,year:year});
    console.log(plannedBudgetResponse);
    const plannedBudgetCount = plannedBudgetResponse?.data;
    setPlannedBudgetList([plannedBudgetCount?.localPlannedBudget,plannedBudgetCount?.nationalPlannedBudget,plannedBudgetCount?.projectPlannedBudget])
    setTotalPlannedBudget(plannedBudgetCount?.totalPlannedBudget);
    const areaBudgetResponse = await publicApi.apiPublicGetAreaBudgetByCountry({countryId:id,year:year});
   setAreaBudgetList(areaBudgetResponse?.data)
  }

  useEffect(() => {
    getAllYearsList();
  },[]);

  useEffect(() => {
    getBudgetByYear(selectedYear)
  },[selectedYear]);




  return  (
    <section className="regional-data">
      <SectionHeading title={t("country:budget-section:title","Budget Section")} />
      <div className="d-sm-flex align-items-center justify-content-between gap-1 mb-sm-5 mb-3">
        <div className="country-box">{translatedCountry}</div>
        <div className="dropdown-year mb-0 mt-sm-0 mt-3">
          <h6>{t("home:regional:select-year","Select year")}</h6>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-year">{selectedYear}</Dropdown.Toggle>
            <Dropdown.Menu>
              {yearsList.map((year) => (
                <Dropdown.Item
                  key={year}
                  onClick={() => handleSelect(year)}
                  active={selectedYear === year}
                >
                  {year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      { (totalBudget > 0 || totalPlannedBudget > 0)  && <div className="row gy-lg-0 gy-3">
      <div className="col-lg-6">
          <div className="chart-card">
            <span className="chart-badge">{selectedYear}</span>
            <h5 className="mb-md-5 mb-3">

              {t("country:budget-section:planned-budget-summary","Planned Budget Allocation for National, Local, and Project Budgets for")} {country} ({selectedCountry?.currency || ''})
            </h5>
            <PlannedAllocationChart categories={[t("country:local-planned","Local Planned"), t("country:national-planned","National Planned"), t("country:project-planned","Project Planned")]} selectedCountry={selectedCountry?.currency || ''} data={plannedBudgetList} title={t("country:planned-budget-allocation","Planned Budget Allocation")} />
            <div className="d-sm-flex align-items-center justify-content-between gap-1 mt-sm-4 mt-1">
              <div className="d-flex align-items-center gap-2">
                <h5 className="font-primary f-s-14 f-w-700">{t("country:budget-section:total-budget-title","Total Budget")}:-</h5>
                <div className="d-flex align-items-center gap-2">
                <div className="currency-div">{selectedCountry?.currency || ''}</div>
                  <span>{formatCurrency(totalPlannedBudget,selectedCountry?.currency || '')}</span>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 mt-sm-0 mt-2">
                <img src="/images/svg/map.svg" alt="Dollar" />
                <span>{country}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="chart-card">
            <span className="chart-badge">{selectedYear}</span>
            <h5 className="mb-md-5 mb-3">
            {t("country:budget-section:planned-spent-budget-summary","Planned and Spent Budget for")} {country} ({selectedCountry?.currency || ''})
            </h5>
            <div className="row align-items-center gy-sm-0 gy-2">
              <div className="col-xxl-6 col-xl-7 col-sm-8">
                <PlannedSpentBudgetChart selectedCountry={selectedCountry?.currency || ''} data={budgetList} />
              </div>
              <div className="col-xxl-6 col-xl-5 col-sm-4">
                <div className="d-flex align-items-center gap-2 mb-4 flex-wrap">
                  <h5 className="font-primary f-s-14 f-w-700">
                  {t("country:budget-section:total-budget-title","Total Budget")}:-
                  </h5>
                  <div className="d-flex align-items-center gap-2">
                    <div className="currency-div">{selectedCountry?.currency || ''}</div>
                    {/* <img src="/images/svg/dollar.svg" alt="Dollar" /> */}
                    <span>{formatCurrency(totalBudget,selectedCountry?.currency || '')}</span>
                  </div>
                </div>
                <ul className="legends-group">
                  <li>
                    <img
                      src="/images/png/planned-spent-chart1.png"
                      alt="planned-spent-chart1"
                    />
                    <span> {t("country:budget-section:plan-budget-title","Plan Budget")}</span>
                  </li>
                  <li>
                    <img
                      src="/images/png/planned-spent-chart2.png"
                      alt="planned-spent-chart2"
                    />
                    <span>{t("country:budget-section:spent-budget-title","Spent Budget")}</span>
                  </li>
                </ul>
                <div className="d-flex align-items-center gap-3 mt-4 pt-xl-5">
                  <img src="/images/svg/map.svg" alt="Dollar" />
                  <span>{country}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div className="col-12">
          <div className="budget-distribution">
            <div className="d-flex gap-5">
              <div className="d-lg-block d-none">
                <div className="vertical-design"></div>
              </div>
              <div>
        
                <h6>{t("country:budget-section:budget-distribution-title-left","Budget Distribution Across Diffrent Sectors")} ({selectedYear})</h6>
                <BudgetDistributionChart data={areaBudgetList} />
              </div>
            </div>
            <div>
              <h5 className="f-s-28 f-w-400 mb-lg-5 mb-3">
              {t("country:budget-section:budget-distribution-title-right","Annual Budget Distribution Across Key Sectors")}
              </h5>
              <p>
              {t("country:budget-section:budget-distribution-description","The pie chart represents the annual budget distribution across key sectors:")}
              </p>
              <ul>
                <li>
                  <span>Education</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-1","indicating a strong focus on educational development.")}
                </li>
                <li>
                  <span>Healthcare</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-2","importance of public health investments")}

                </li>
                <li>
                  <span>Infrastructure</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-3","emphasizing the development of physical and organizational structures.")}

                </li>
                <li>
                  <span>Housing receives</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-4","addressing the need for residential improvements.")}

                </li>
                <li>
                  <span>Defense</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-5","maintaining national security priorities.")}
                </li>
                <li>
                  <span>Technology</span> &nbsp;
                  {t("country:budget-section:budget-distribution-summary-6","highlighting investments in innovation and digital advancements.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>}
    </section>
  ) ;
}

export default CountryBudget;
